import {Model} from "@vuex-orm/core";

export default class WebsiteProductTagTypeWebsiteCategory extends Model {

    static entity = 'websiteProductTagTypeWebsiteCategory';

    static primaryKey = ['website_product_tag_type_id', 'website_category_id'];

    static fields () {
        return {
            website_product_tag_type_id: this.number(null).nullable(),
            website_category_id: this.number(null).nullable(),
        }
    }
}
